export class BreadCrumb {
    constructor(
        public title: string,
        public action: (a: any) => void | null
    ) { }
}
